import { Injectable } from '@angular/core';

import { FeatureFlagData } from './feature-flag-data.model';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {

  private flags: FeatureFlagData[] = [];

  constructor(private http: HttpClient) {
    (window as any).NG_SHARED_FEATURE_FLAGS_SERVICE = this;
  }

  public init(): void {
    this.adoptPreviousUserPreferencesFromLocalStorage();
  }

  public isOn(key: string): boolean {
    const found = this.flags.find(flag => flag.key === key);
    return found ? found.active : false;
  }

  public isOff(key: string): boolean {
    return !this.isOn(key);
  }

  public setFlags(flags: FeatureFlagData[]) {
    this.flags = flags;

    // Make the list alphabetical by name
    this.flags.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  }

  public getFlags(type?: string): FeatureFlagData[] {
    return this.flags.filter(flag => (flag.type === type || !type));
  }

  public updateFlagValue(updatedFlag: FeatureFlagData) {
    this.updateFlagGlobal(updatedFlag);
    this.updateFlagLocalStorage(updatedFlag);
  }

  public resetFlagsToDefault() {
    this.flags.forEach((flag: FeatureFlagData) => {
      flag.active = flag.activeDefault;
      this.updateFlagValue(flag);
    });
  }

  private adoptPreviousUserPreferencesFromLocalStorage() {
    this.flags.forEach((flag) => {
      const val = localStorage.getItem(this.prefixedFlag(flag.key));
      flag.active = val === 'true' ? true : val === 'false' ? false : flag.active;
    });
  }

  private prefixedFlag(key: string) {
    return 'featureFlags.sb.' + key;
  }

  private updateFlagGlobal(updatedFlag: FeatureFlagData) {
    this.flags = this.flags.map((flag) => {
      if (flag.key === updatedFlag.key) {
        flag.active = updatedFlag.active;
      }
      return flag;
    });
  }

  private updateFlagLocalStorage(updatedFlag: FeatureFlagData) {
    localStorage.setItem(this.prefixedFlag(updatedFlag.key), String(updatedFlag.active));
  }
}
